import { SvgIcon, SvgIconProps } from '@mui/material';

/**
 * CcfOpenNewTabIcon used to disply open new tab icon in the custom workspace iframe panel
 * @param props - SvgIconProps
 * @example -- <CcfOpenNewTabIcon />
 */
export function CcfViewInNewWindowIcon(props: SvgIconProps) {
  return (
    <SvgIcon {...props}>
      <svg width="90" height="100" viewBox="0 0 150 150" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M36 0H4C1.8 0 0 1.8 0 4V28C0 30.2 1.8 32 4 32H36C38.2 32 40 30.2 40 28V4C40 1.8 38.2 0 36 0V0ZM12 4H16V8H12V4V4ZM4 4H8V8H4V4V4ZM36 28H4V12H36V28ZM36 8H20V4H36V8Z" fill="#767676"/>
      </svg>
    </SvgIcon>
  );
}

export default CcfViewInNewWindowIcon;